import styled from 'styled-components';

export const Container = styled.form`
  .headerModal {
    display: flex;
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.5rem;
    font-weight: bold;
    justify-content: space-between;

    p {
      display: flex;
      gap: 0.5rem;
      align-items: center;
    }

    .close-div {
      padding: 0;
      height: 20px;
      button {
        color: #fff;
        background-color: ${({ theme }) => theme.colors.tertiary_500};
        width: 20px;
        height: 19px;
        border-radius: 100%;
        padding: 0;
        border: none;

        :hover {
          cursor: pointer;
        }
      }
    }

    p {
      margin: 0 0 0 0.4rem;
    }
  }

  .contentModal {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.5rem;

    .containerNote {
      display: flex;
      align-items: center;
      flex-direction: column;
      .note {
        width: 100%;
        max-width: 30rem;
        min-height: 10rem;
        max-height: 10rem;
        padding: 0.5rem;
        border-radius: 1rem;
        font-size: 1.2rem;
        overflow-y: auto;
        resize: none;
        margin-top: 0.5rem;
        border-color: ${({ theme }) => theme.colors.primary};
      }
    }

    .buttonModal {
      display: flex;
      width: 100%;
      justify-content: space-around;
      padding-bottom: 1.5rem;
    }
  }

  @media (max-width: 380px) {
    .contentModal .buttonModal {
      justify-content: center;
    }
  }
`;
